import React from 'react';
import { Badge, IconButton, Tooltip, styled } from '@mui/material';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';

// Badge personalizado para garantir que o contador seja exibido corretamente
const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    fontSize: '0.7rem',
    height: '20px',
    minWidth: '20px',
    padding: '0 6px',
    right: -3,
    top: 3,
    border: `2px solid ${theme.palette.background.paper}`,
    transform: 'none',
  },
}));

interface IconeNotificacaoProps {
  contador: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  titulo?: string;
}

const IconeNotificacao: React.FC<IconeNotificacaoProps> = ({
  contador,
  onClick,
  titulo = 'Notificações',
}) => {
  return (
    <Tooltip title={titulo}>
      <IconButton
        color="inherit"
        onClick={onClick}
        aria-label={titulo}
        sx={{
          position: 'relative',
          padding: '8px',
          height: '40px',
          width: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <StyledBadge
          badgeContent={contador}
          color="error"
          max={99}
          overlap="circular"
        >
          <NotificationsNoneRoundedIcon />
        </StyledBadge>
      </IconButton>
    </Tooltip>
  );
};

export default IconeNotificacao; 